<form nz-form (ngSubmit)="checkValidation()" [formGroup]="formGroup" [nzLayout]="'vertical'">
    <div nz-row [nzGutter]="16">
        <div nz-col nzSpan="12">
            <nz-form-item>
                <nz-form-label nzFor="modelProvider" nzRequired>Model Provider</nz-form-label>
                <nz-form-control nzErrorTip="Model Provider is required">
                    <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
                          <nz-select formControlName="modelProvider" [nzAllowClear]="true" (ngModelChange)="onModelProviderChange($event)">
                            <nz-option *ngFor="let item of modelProviders" [nzValue]="item"
                                [nzLabel]="item"></nz-option>
                        </nz-select>
                    </nz-input-group>
                    <ng-template #suffixIconButton>
                        <button nz-button nzType="primary" nzSearch [disabled]="!formGroup.get('modelProvider').value" (click)="openModelsModal()" title="Query Available Models"><i nz-icon nzType="search"></i></button>
                    </ng-template>
                </nz-form-control>
            </nz-form-item>


        </div>
        <div nz-col nzSpan="12">
            <nz-form-item>
                <nz-form-label nzFor="modelId" nzRequired>Model ID</nz-form-label>
                <nz-form-control nzErrorTip="Model ID is required">
                    <input nz-input type="text" formControlName="modelId">
                </nz-form-control>
            </nz-form-item>
        </div>
    </div>


    <div nz-row [nzGutter]="16">
    </div>

    <div nz-row [nzGutter]="16">
        <div nz-col nzSpan="24">
            <nz-form-item>
                <nz-form-label nzFor="apiEndpoint" nzRequired>API Endpoint</nz-form-label>
                <nz-form-control nzErrorTip="API Endpoint is required">
                    <input nz-input type="text" formControlName="apiEndpoint">
                </nz-form-control>
            </nz-form-item>
        </div>
    </div>

    <div nz-row [nzGutter]="16">
        <div nz-col nzSpan="24">
            <nz-form-item>
                <nz-form-label nzFor="apiKey" nzRequired>API Key</nz-form-label>
                <nz-form-control nzErrorTip="API Key is required">
                    <input nz-input type="text" formControlName="apiKey">
                </nz-form-control>
            </nz-form-item>
        </div>
    </div>

    <div style="text-align: center; margin-top: 20px;">
        <button type="button" nz-button nzType="default" (click)="cancel()" style="margin-right: 10px;">
            Cancel
        </button>
        <button type="submit" nz-button nzType="primary">
            Save
        </button>
    </div>
</form>